import axios from 'axios';
import { configData } from '../../../config';


axios.defaults.baseURL = configData.API_URL;

export const axiosRequest = async (params) => {
  
    try {
      params.headers = { ...params.headers };
      const result = await axios.request(params);
      
      return result?.data;
     } catch(error) {
     // 
       let customErr = new Error(error.response.data.message);
       customErr.status  = error.response.status;
       throw customErr;
     } 
 };